<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
    <div class="subBlockContainer" id='levelOne'>
        <div class="breadcrumbWrapper">
            <app-breadcrumb></app-breadcrumb>
        </div>

        <div class="child-loader">
            <div class="subBlockContainer toplevel" [ngStyle]="{'width': toplevelWidth}">
                <div class="subBlockContent" id="win-11-report">
                    <child-header title="Windows 11 Readiness Assessment" (closeEvent)="close()"></child-header>
                    <div #ParentWrapper class="inner-subBlock-wrapper">
                        <div style="position: relative; width: 100%;">
                            <img src="https://www.dickerdata.com.au/hubfs/windows-11/Hero%20Image.png" style="width: 100%; height: 100%; object-fit: contain;" 
                            alt="windows-11-png">

                            <div style="
                            position: absolute;
                            top: 40%;
                            left: 50%;
                            transform: translate(-50%, -60%);
                            color: white;
                            text-align: center;
                            ">
                                <img src="https://www.dickerdata.com.au/hubfs/windows-11/DD%20Logo.png" style="width: 100%; max-width: 120px; height: 100%; margin-bottom: 20px;">
                                <h2 class="heading-style">Start the Windows 10 Refresh Conversation with Confidence</h2>
                                <h6 class="subheading-style">Take the first step with Dicker Data's free Windows 10 <br>readiness assessment tool today</h6>
                            </div>
                        </div>

                        <div class="middle-box" style="            
                        margin-top: -100px;
                        z-index: 9999;
                        position: sticky;">
                            <p class="middle-box-styling">Generate your FREE report for your customers using Dicker Data's<br>
                            Windows 11 Readiness Assessment tool.</p>
                            <!-- <button class="cta-button">Generate Report</button> -->
                            <p class="privacy-note">
                                Any personal information you provide will not be disclosed to any third-party organisations.
                                See our <a href="#">Privacy Policy</a>.
                            </p>
                        </div>

                        <div class="windows-11-twoBoxes">
                            <div class="get-started">
                                <h2>Get Started</h2>
                                <p>Follow the below simple two step process.</p>
                            </div>

                            <div class="steps-container">
                                <div class="step">
                                    <div class="circle-badge">
                                    <div class="step-number-container">
                                        <span class="step-number ">1</span>
                                    </div>
                                    </div> 
                                    <h3>Export Your Data</h3>
                                    <p>Follow the steps below to export your data from Microsoft Intune, Active Directory, SCCM or PC Health Check.</p>
                                    <button class="upload-button" (click)="goToDetails()">Download File</button>
                                </div>
                                <div class="step">
                                    <div class="circle-badge">
                                    <div class="step-number-container">
                                        <span class="step-number ">2</span>
                                    </div>
                                    </div>
                                    <h3>Upload Your Data</h3>
                                    <p>Upload your chosen data export method into our secure Windows 11 readiness tool to receive your report.</p>
                                    <button class="upload-button" (click)="browseIntuneFile()">Upload File</button>
                                    <input #fileUploadInput name="fileNames" type="file" class="ng2fup-file-input" (change)="onSelectFiles($event)" accept=".csv"
                                        style="visibility: hidden;height: 0;" />
                                </div>
                            </div>

                            <div class="discover-section">
                                <h2>Discover your refresh options with Dicker Data</h2>
                                <div class="logo-container">
                                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Dell%20Logo.png" alt="Dell Technologies">
                                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Lenovo%20Logo.png" alt="Lenovo">
                                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/HP.png" alt="HP">
                                    <img src="https://www.dickerdata.com.au/hubfs/windows-11/Dynabook.png" alt="Dynabook">
                                </div>
                            </div>
                        </div>

                        <div class="what-to-expect-section">
                            <h2>What To Expect</h2>
                            <p>Dicker Data's Windows 11 Readiness Tool automatically converts the data <br>you upload into an easy to read, simplified view of what you need to do next, including:</p>

                            <div class="features-grid">
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Devices already running Windows 11</p>
                                </div>
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Devices that are not capable of running Windows 11</p>
                                </div>
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Devices running Windows 10 which can be upgraded to Windows 11</p>
                                </div>
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Estimated cost for purchasing new devices</p>
                                </div>
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Devices that require investigation to confirm if they can run Windows 11</p>
                                </div>
                                <div class="feature-item">
                                    <span class="icon">
                                        <img src="https://www.dickerdata.com.au/hubfs/windows-11/tickIcon.gif">
                                    </span>
                                    <p>Provides Information on Extended Security Updates (ESU)</p>
                                </div>
                            </div>

                            <!-- <div class="generate-report-btn-container">
                            <button class="generate-report-btn">Generate Report</button>
                            </div> -->
                        </div>

                        <div class="doing-nothing-section">
                            <h2>The Cost Of Doing Nothing</h2>
                            <p class="doing-nothing-subtitle">The cost of inaction is too significant to ignore</p>
                            <div class="DN-image-container">
                                <img class="side-by-side-left" src="https://www.dickerdata.com.au/hubfs/windows-11/cost%20of%20nothing%20left.png" alt="">
                                <img class="side-by-side-right" src="https://www.dickerdata.com.au/hubfs/windows-11/Zero%20Access.png" alt="">
                            </div>
                        </div>

                        <div class="windows-11-footer">
                            <div class="overlay"></div>
                            <div class="windows-11-footer-text-content">
                                <h1>Don't delay!</h1>
                                <p>Analyse your customers' readiness with Dicker Data today!</p>
                                <!-- <a class="footer-cta-button" href="#goToTop">Generate Report</a> -->
                                <!-- <a href="#" class="back-to-top" title="Back to Top" >
                                    <i class="fa fa-chevron-up fa-2x"></i>
                                </a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>